import { axiosInstance } from "../../../util/axios";
import { assemblyGuideBaseUrlSelector } from "../../../Api/ApiHelper";

export const fetchAssemblyGuideByArticleNumber = ({ articleNumber, lang }) => {
  const baseUrl = assemblyGuideBaseUrlSelector();
  const url = `${baseUrl}?id=${articleNumber}&lc=${lang}`;
  return axiosInstance.get(url);
};
